module.exports = __webpack_public_path__ + "static/img/bg_zpxqy.65ff191.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PC/bg_zpxqy.png
// module id = eLYz
// module chunks = 1